<div
  class="archive-menu"
  [ngStyle]="{ visibility: contextMenuVisibility }"
  (clickOutside)="onClickOutside()"
>
  <button
    class="context-menu-button"
    [matMenuTriggerFor]="aboveMenu"
    #menuTrigger="matMenuTrigger"
    (menuClosed)="contextMenuImage = 'expand_more'; setContextMenuVisibility()"
    (menuOpened)="contextMenuImage = 'expand_less'"
    (click)="onMenuClick($event)"
  >
    <span class="material-icons">
      {{ contextMenuImage }}
    </span>
  </button>
  <mat-menu
    [hasBackdrop]="false"
    #aboveMenu="matMenu"
    xPosition="after"
    yPosition="below"
  >
    <button mat-menu-item *ngIf="!archived" (click)="archive()">
      Arquivar
    </button>
    <button mat-menu-item *ngIf="archived" (click)="unarchive()">
      Desarquivar
    </button>
    <button mat-menu-item *ngIf="unread" (click)="markAsRead()">
      Marcar como lida
    </button>
    <button mat-menu-item *ngIf="!unread" (click)="markAsUnread()">
      Marcar como não lida
    </button>
  </mat-menu>
</div>
